(function () {
    'use strict';

    /**
     * @ngdoc overview
     * @name index
     * @description
     * Enlaces sobre la documentación:
     *
     * {@link https://github.com/CodeineLabs/gulp-ngdocs-components}
     *
     * {@link https://github.com/nikhilmodak/gulp-ngdocs}
     *
     * {@link https://github.com/angular/angular.js/wiki/Contribution%3A-Writing-AngularJS-Documentation}
     */

    /**
     * @ngdoc overview
     * @name app
     * @description
     * Módulo base de la aplicación.
     */
    angular.module('app', [
        'ui.bootstrap',
        'ui.router',
        'angular-loading-bar',
        'angularjs-dropdown-multiselect',
        'jcs-autoValidate',
        'ncy-angular-breadcrumb',
        'ngAnimate',
        'ngCacheBuster',
        'ngCookies',
        'ngFileUpload',
        'ngResource',
        'ngSanitize',
        'ngStorage',
        'ngTable',
        'ngTagsInput',
        'oc.lazyLoad',
        'pascalprecht.translate',
        'tmh.dynamicLocale',
        'vcRecaptcha',
        '720kb.socialshare',
        'thatisuday.ng-image-gallery'
    ]).run(appRun);

    /* @ngInject */
    function appRun($rootScope, $translate, $localStorage, StateHandler, ValidateConfig, TranslationHandler) {

        TranslationHandler.initialize();
        StateHandler.initialize();
        ValidateConfig.initialize();

        $rootScope.changeLanguage = function (key) {
            if ($translate.use() !== key) {
                $translate.use(key).then(function () {
                    $translate.refresh();
                });
                $localStorage.lang = key;
            }
        };
    }
})();
